export default __webpack_public_path__ + "static/media/offering2.4f491678.png";